import Axios from "../config/config";

//Download api

export const DOWNLOAD_QUIZ_REPORT= async (body) => {
    try {
        const response = await Axios.post('download-quiz-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DOWNLOAD_PACKAGE_EXCEL= async (body) => {
    try {
        const response = await Axios.post('download-package-excel/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_DOWNLOAD_COURSE_REPORT= async (body) => {
    try {
        const response = await Axios.post('list-download-course-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const GET_DOWNLOAD_REPORT= async (body) => {
    try {
        const response = await Axios.post('get-download-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const DOWNLOAD_REPORT= async (body) => {
    try {
        const response = await Axios.post('download-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_DOWNLOAD_PACKAGE_REPORT= async (body) => {
    try {
        const response = await Axios.post('list-download-package-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_DOWNLOAD_QUIZ_TEST_REPORT= async (body) => {
    try {
        const response = await Axios.post('list-download-quiz-test-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_DOWNLOAD_COURSE_QUIZ_REPORT= async (body) => {
    try {
        const response = await Axios.post('list-download-course-quiz-report/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
